import axios from 'axios';
import * as utils from './Utils';

export function convertCentsToAmount(cents) {
  if (!cents) return 0;
  return parseFloat((cents / 100.0).toFixed(2));
}

export function extractHandleFromShopifyUrl(url) {
  if (!window.Shopify) return;

  let regex = /\/products\/((?!\?|\$|\/).)+/g;
  let matches = url.match(regex);
  let handle = matches[0] || '';
  handle = handle.replaceAll('/products/', '');
  return handle;
}

function deserializeProductPrice(product, data) {
  product.setPrice(convertCentsToAmount(data.price) || 0);
  product.setCompareAtPrice(convertCentsToAmount(data.compare_at_price) || 0);
  product.setDiscountAmount(product.compareAtPrice > product.price ? product.compareAtPrice - product.price : 0);

  if (window.Shopify && window.Shopify.currency) {
    product.setCurrency(window.Shopify.currency.active);
  }

  if (product.variants && product.variants.length > 0) {
    data.variants.forEach((variantData) => {
      let variant = product.variants.filter((variant) => `${variant.id}` === `${variantData.id}`)[0];
      if (!variant) return;

      variant.setPrice(convertCentsToAmount(variantData.price) || 0);
      variant.setCompareAtPrice(convertCentsToAmount(variantData.compare_at_price) || 0);
    })
  }
}

export function fetchProductPrices(products, callback) {
  const product = products[0];
  if (!product) {
    callback();
    return;
  }

  // check if need to load product data from Shopify using ajax
  // required if using different currency
  if (window.Shopify && window.Shopify.currency) {
    if (product.currency === window.Shopify.currency.active) {
      callback();
      return;
    }
  }

  function fetchData(product) {
    const handle = extractHandleFromShopifyUrl(product.url);
    return axios
      .get(`/products/${handle}.js`)
      .then(function(response) {
        deserializeProductPrice(product, response.data);
      })
      .catch(function(error) {
        console.error(error);
      });
  }

  function getAllData(){
    return Promise.all(products.map(fetchData));
  }

  getAllData()
  .then(resp => {
    callback(resp);
  })
  .catch(error => {
    console.error(error);
  })
}

export function convertProductCurrency(product) {
  // Grizzly Apps: BEST Currency Converter
  // https://apps.shopify.com/doubly-currency-converter
  if (typeof DoublyGlobalCurrency !== 'undefined') {
    try {
      DoublyGlobalCurrency.convertAll(DoublyGlobalCurrency.currentCurrency);
    } catch(error) {
      console.error(error);
    }
  }

  // MLVeda: Auto Currency Switcher
  // https://apps.shopify.com/auto-currency-switcher
  if (typeof mlvedaShopCurrency !== 'undefined' && typeof Currency !== 'undefined') {
    try {
      Currency.convertAll(product.currency, Currency.currentCurrency, "span.money", Currency.format);
    } catch(error) {
      console.error(error);
    }
  }
}
